// extracted by css-extract-rspack-plugin
export default {"wrapper":"_37d903f1","active":"_9a0d58e","large":"_9ecd739f","medium":"_ebfb707f","small":"_59f807d"};